import { render, staticRenderFns } from "./VizNowForm.vue?vue&type=template&id=2c70a936"
import script from "./VizNowForm.vue?vue&type=script&lang=ts"
export * from "./VizNowForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports